const solucoesItems = {
  heading:
    "Criamos <span style='color:#0fd24f'>impacto positivo</span> nas organizações",
  paragraph:
    "Oferecemos soluções que tragam significado e emoção. Reimaginamos o seu futuro e a narrativa coletiva nos temas importantes para a sociedade, em consonância com os valores e as necessidades estratégicas das organizações.",
};

export default solucoesItems;
